import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilOptions, cilPencil, cilTrash } from '@coreui/icons'

import ToastComponent from 'src/components/common/TaostComponent.js'
import GradeService from 'src/service/GradeService'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'
import TeamsModal from './TeamsModal'

const columns = [
  {
    label: 'Comp Code',
    key: 'sn',
    _style: { width: '20%' },
  },
  { label: 'Comp Name', key: 'grade', _style: { width: '20%' } },
  {
    label: 'Teams',
    key: 'team_count',
    _style: { width: '15%' },
    filter: false,
    sorter: false,
  },
  {
    key: 'actions',
    label: 'Actions',
    _style: { width: '1%' },
    filter: false,
    sorter: false,
  },
]

const Table = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnFilter,
  columnSorter,
  onEditGrade,
}) => {
  const [loading, setLoading] = useState(false)
  const [teamsGrade, setTeamsGrade] = useState(null)

  const deleteGrade = (id) => {
    setLoading(true)
    GradeService.deleteGrade({ id }).then((res) => {
      if (res.status === 200) {
        fetchUsers()
        ToastComponent(res.message, 'success')
      }
      setLoading(false)
    })
  }

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)
  const handleCancel = () => setShowConfirm(false)

  const handleConfirm = () => {
    deleteGrade(tableId)
    return setShowConfirm(false)
  }

  const areYouSureModal = (id) => {
    const data = { id, type: 'grade' }
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }

  useEffect(() => {
    const offset = itemsPerPage * activePage - itemsPerPage
    fetchUsers(offset, itemsPerPage, activePage, columnFilter, columnSorter)
  }, [activePage, columnFilter, columnSorter, itemsPerPage, fetchUsers])

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)
  const showPagination = totalPages > 1

  return (
    <div className="ge-datatable ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          grade: (item) => (
            <td>
              <span
                className="fw-semibold text-primary"
                role="button"
                onClick={() => onEditGrade(item.id)}
              >
                {item.grade}
              </span>
            </td>
          ),
          team_count: (item) => {
            const count = Number(item.team_count) || 0
            return (
              <td>
                {count > 0 ? (
                  <CBadge
                    color="primary"
                    shape="rounded-pill"
                    role="button"
                    title="View teams"
                    onClick={() => setTeamsGrade(item)}
                  >
                    {count}
                  </CBadge>
                ) : (
                  <CBadge color="secondary" shape="rounded-pill">
                    0
                  </CBadge>
                )}
              </td>
            )
          },
          actions: (item) => (
            <td className="py-2">
              <CDropdown alignment="end">
                <CDropdownToggle color="transparent" caret={false} className="p-0">
                  <CIcon icon={cilOptions} role="button" />
                </CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem role="button" onClick={() => onEditGrade(item.id)}>
                    <CIcon icon={cilPencil} className="me-2" />
                    Edit
                  </CDropdownItem>
                  <CDropdownItem
                    role="button"
                    className="text-danger"
                    onClick={() => areYouSureModal(item.id)}
                  >
                    <CIcon icon={cilTrash} className="me-2" />
                    Delete
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={showPagination ? { external: true } : false}
        paginationProps={
          showPagination
            ? {
                activePage: activePage,
                pages: totalPages,
              }
            : undefined
        }
        tableProps={{
          hover: true,
          responsive: true,
          className: 'align-middle mb-0',
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
      <TeamsModal grade={teamsGrade} visible={!!teamsGrade} onClose={() => setTeamsGrade(null)} />
    </div>
  )
}

export default Table
